module.exports = __webpack_public_path__ + "b5274b3b6c1c6100f3a4f999c48823f1.svg";